import { gql } from '@apollo/client';
import { ProductConnection } from '@interfaces';
import { ProductBaseSearchFragment } from '../fragments';

export const ProductQuery = (name: string) => gql`
    query ${name} ($params: ProductsParams){
        products(params: $params) {
          nodes{
            ...ProductBaseSearch
          }
          pageInfo{
            totalPages
            pageNumber
          }
          totalCount
          suggestionText
          query
          pageNumber
          suggestionNodes {
            ...ProductBaseSearch
          }
          perfectMatchProducts {
            ...ProductBaseSearch
          }
      }
    }
    ${ProductBaseSearchFragment}
`;

export type ProductQueryResponse = {
  products: ProductConnection;
};
export type ProductQueryParams = {
  params: {
    query: string;
    pageNumber?: number;
  };
};
